module.exports = "<span *ngFor=\"let step of _steps; let i=index\" [style.width]=\"segmentWidth\"\n    [class.active]=\"i === completedSteps\" [class.completed]=\"i < completedSteps\">\n    {{ i + 1 }}. {{ step }}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/progress-bar/progress-bar.template.html
// module id = ../../../../../src/app/shared/components/progress-bar/progress-bar.template.html
// module chunks = 12